const $header = $('.kaspersky-inc-header');

function setState(stateName) {
	if (stateName === 'reset') {
		$header.removeClass('is-playing is-finished is-disabled');
	} else if (stateName === 'play') {
		$header.addClass('is-playing');
	} else if (stateName === 'finish') {
		$header.addClass('is-finished');
	}
}

function disable(state) {
	$header.toggleClass('is-disabled', state);
}

function show() {
	$header.removeClass('is-hidden');

	gsap.from($header, {
		duration: 0.5,
		opacity: 0,
		yPercent: -100,
		clearProps: 'all',
	});
}

function hide() {
	return new Promise((resolve) => {
		gsap.to($header, {
			onComplete() {
				$header.addClass('is-hidden');

				resolve();
			},
			duration: 0.3,
			opacity: 0,
			clearProps: 'all',
		});
	});
}

export default {
	setState,
	disable,
	show,
	hide,
};
